var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('header', {
    staticClass: "header-container"
  }, [_c('div', {
    staticClass: "header-titles"
  }, [_vm.$slots.subtitle ? _c('h2', [_vm._t("subtitle")], 2) : _vm._e(), _vm._v(" "), _vm.$slots.default ? _c('h3', [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm.$slots.project ? _c('h3', {
    staticClass: "project-title"
  }, [_vm._t("project")], 2) : _vm._e(), _vm._v(" "), _vm.$slots['modal-title'] ? _c('h3', {
    staticClass: "modal-title"
  }, [_vm._t("modal-title")], 2) : _vm._e(), _vm._v(" "), _vm.$slots['lower-subtitle'] ? _c('h4', [_vm._t("lower-subtitle")], 2) : _vm._e()]), _vm._v(" "), _vm.modalButton ? _c('div', {
    staticClass: "header-close"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "aria-label": "close modal"
    },
    on: {
      "&click": function ($event) {
        return _vm.$emit('close-modal');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.closeIconSrc,
      "alt": "close button"
    }
  })])]) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }